import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getPref, setPref } from "../lib/prefs";

const PREF_KEY = "onboarding_done";

const OnboardingContext = createContext({
  open: false,
  start: () => {},
  close: () => {},
});

export const OnboardingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  // Auto-start once per user (cookie flag) on first dashboard visit
  useEffect(() => {
    const done = getPref(PREF_KEY);
    if (!done && window.location.pathname.startsWith("/dashboard")) {
      // Small delay so the dashboard renders first
      const t = setTimeout(() => setOpen(true), 600);
      return () => clearTimeout(t);
    }
    return undefined;
  }, []);

  const start = useCallback(() => setOpen(true), []);
  const close = useCallback(() => {
    setPref(PREF_KEY, true);
    setOpen(false);
  }, []);

  return (
    <OnboardingContext.Provider value={{ open, start, close }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => useContext(OnboardingContext);
